/**
 * The genre blends worth showing the Prompt Doctor (AUTO-103): only the ones the style text actually names.
 *
 * TabRenderer used to pass the Studio form's current blends straight in. After a Studio Roulette roll the form
 * can still hold genres (Country, K-Pop, Gospel) that the song being examined does not contain, and the Doctor's
 * request then said "GENRE BLENDS: Contemporary Country, K-Pop, Gospel", so it "removed conflicting genre blends"
 * from a doom-metal prompt that never had them.
 */
function norm(text: string): string {
  return ` ${text.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim()} `;
}

export function blendsInStyle(styleText: string, blends: readonly string[] | null | undefined): string[] {
  if (!blends || blends.length === 0) return [];
  const haystack = norm(styleText || '');
  return blends.filter(b => {
    const needle = norm(b || '');
    return needle.trim() !== '' && haystack.includes(needle);
  });
}
